import React from 'react'
import Autosuggest from 'react-autosuggest';

// Fetch suggestions from API using native fetch
const getSuggestions = async (value) => {
  if (value === undefined) {
    return [];
  }

  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  if (inputLength === 0) {
    return [];
  }

  try {
    const response = await fetch(`/drugs?q=${encodeURIComponent(inputValue)}`);
    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error('Error fetching drug suggestions:', error);
    return [];
  }
};

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion.
const getSuggestionValue = (suggestion) => {
  return suggestion.name;
};

// Render suggestion item
const renderSuggestion = (suggestion) => {
  let genericText = '';

  if (suggestion.is_generic) {
    genericText = '(Generic)';
  } else if (suggestion.generic_name) {
    genericText = `(${suggestion.generic_name})`;
  }

  const classification = suggestion.classification === 'non-prescription'
    ? 'Non-Prescription'
    : '';

  return (
    <div>
      <span className='brand_name'>{suggestion.name}</span>
      <span className='generic_name'> {genericText}</span>
      {classification && <div className='drug_classication'>{classification}</div>}
    </div>
  );
};

class DrugSearch extends React.Component {
  constructor() {
    super();

    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value.
    this.state = {
      value: '',
      suggestions: []
    };
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  onSuggestionsFetchRequested = async ({ value }) => {
    const suggestions = await getSuggestions(value);
    this.setState({ suggestions });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  render() {
    const { value, suggestions } = this.state;

    const inputProps = {
      placeholder: 'Search for a drug',
      value,
      onChange: this.onChange,
      name: "q"
    };

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
    );
  }
}

export default DrugSearch
